// This function gets and returns a the data
// of a country using the countryCode

import { getAllActiveCountries } from "./getAllActiveCountries"

export const getCountryNames = countryCode => {
  const countries = getAllActiveCountries()
  let names = []

  countries.forEach(country => {
    names.push(country.name)
  })

  return names
}
